<template>
  <div class="rule-view flex flex-col">
    <page-header
      back="/automation"
      :title="rule ? rule.name : tr('Loading...')"
    >
      <template v-if="rule" #title-prepend>
        <rule-type-badge :action="rule.action" :ai="rule.group_id !== null" compact />
      </template>

      <form-step-tab :items="tabs" stretch />
    </page-header>

    <router-view />
  </div>
</template>

<script>
import RuleService from '@/services/Rule.js';
import FormStepTab from '@/ui/components/FormStepTab.vue';
import PageHeader from '@/ui/components/PageHeader.vue';
import RuleTypeBadge from '@/ui/components/RuleTypeBadge.vue';

export default {
  name: 'RuleView',
  components: {
    FormStepTab,
    RuleTypeBadge,
    PageHeader,
  },
  provide() {
    return { ruleView: this };
  },
  beforeRouteUpdate(to, from, next) {
    next();

    // this.$route still points to the previous rule here, hence the id from `to`.
    if (to.params.id !== from.params.id) {
      this.rule = null;
      this.fetch(to.params.id);
    }
  },
  data: () => ({
    rule: null,
    isLoading: true,
  }),
  computed: {
    id() {
      return this.$route.params.id;
    },
    tabs() {
      const tabs = [];

      tabs.push({
        label: this.tr('Overview'),
        link: `/automation/${this.id}/overview`,
      });

      tabs.push({
        label: this.tr('Waiting list'),
        link: `/automation/${this.id}/waiting-list`,
      });

      tabs.push({
        label: this.tr('Edit history'),
        link: `/automation/${this.id}/edit-history`,
      });

      if (this.rule && (this.rule.action === 'start' || this.rule.action === 'scaling_up')) {
        tabs.push({
          label: this.tr('Report'),
          link: `/automation/${this.id}/report`,
        });

        if (this.rule.ad_creation_details?.leadgen_form_id) {
          tabs.push({
            label: this.tr('Leads'),
            link: `/automation/${this.id}/leads`,
          });
        }
      }

      tabs.push({
        label: this.tr('Error log'),
        link: `/automation/${this.id}/error-logs`,
      });

      return tabs;
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch(id = this.id) {
      this.isLoading = true;

      RuleService.get(id)
        .then(response => this.rule = response)
        .catch(error => {
          this.error(error);
          this.$router.replace('/automation');
        })
        .finally(() => this.isLoading = false);
    },
  },
};
</script>
